import {Component, ViewChild} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {StoreSelectorsService} from "../../../../services";
import {animate, state, style, transition, trigger} from '@angular/animations';
import {IBaseBlockComponent, ISceneItemNewValues} from "../../../../interfaces";
import {actionUpdateSceneItem} from "../../../../store/actions/user.actions";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {ButtonBarComponent, IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITableListColumn} from '../../../../components/table-list-input/table-list-input.component';
import {ToastrService} from "ngx-toastr";
import * as _ from "lodash";

@Component({
    selector: 'app-scene-block-rss',
    templateUrl: './block-rss.component.html',
    styleUrls: ['./block-rss.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class BlockRssComponent extends BlockBaseComponent implements IBaseBlockComponent {

    rssEmbeddedDataSource: Array<any> = [];
    showDescriptionFontSelector = true;
    rssNames = [];
    defaultValue = '';
    defaultText = '[click to edit]';
    rssLinks = {
        'https://feeds.nbcnews.com/feeds/topstories': 'US TopStories',
        'https://time.com/newsfeed/feed/': 'Time.com Top Stories',
        'https://feeds.nbcnews.com/feeds/worldnews': 'World News',
        'https://feeds.foxnews.com/foxnews/latest?format=xml': 'US General News',
        'https://www.newsweek.com/rss': 'General News',
        'https://globalnews.ca/canada/feed/': 'Canadian News',
        'https://feeds.feedburner.com/TheAustralianMediaNews': 'Australian News',
        'https://feeds.foxnews.com/foxnews/politics': 'US Politics',
        'https://globalnews.ca/politics/feed/': 'Canadian Politics',
        'https://www.standard.co.uk/news/politics/rss': 'UK Politics',
        'https://rss.nytimes.com/services/xml/rss/nyt/Business.xml': 'US Business',
        'https://www.canadianbusiness.com/feed/': 'Canadian Business',
        'https://feeds.bbci.co.uk/news/business/rss.xml': 'UK Business',
        'https://time.com/health/feed/': 'US Health',
        'https://www.thestar.com/feeds.articles.life.health_wellness.rss': 'Canadian Health',
        'https://feeds.bbci.co.uk/news/health/rss.xml': 'UK Health',
        'https://feeds.nbcnews.com/feeds/science': 'NBC Science',
        'https://tech.yahoo.com/rss': 'Technology',
        'https://www.smithsonianmag.com/rss/science-nature/': 'Science and Nature',
        'https://rss.nytimes.com/services/xml/rss/nyt/Technology.xml': 'US Technology',
        'https://feeds.arstechnica.com/arstechnica/gadgets': 'Technology Gadgets',
        'https://sports.yahoo.com/rss': 'Sports now',
        'https://rss.nytimes.com/services/xml/rss/nyt/Sports.xml': 'US Sports',
        'https://www.si.com/rss/si_topstories.rss': 'SI Today',
        'https://www.sportsnet.ca/feed/': 'Canadian Sports',
        'https://feeds.bbci.co.uk/sport/0/rss.xml?edition=uk': 'UK Sports',
        'https://variety.com/feed/': 'US Entertainment',
        'https://www.tmz.com/rss.xml': 'US TMZ',
        'https://www.cbsnews.com/latest/rss/entertainment': 'CBS Entertainment',
        'https://feeds.nbcnews.com/feeds/todayentertainment': 'Entertainment Today',
        'https://news.yahoo.com/rss/world': 'World',
        'https://news.yahoo.com/rss/sports': ' Yahoo Sports',
        'https://news.yahoo.com/rss/us': 'U.S. National',
        'https://news.yahoo.com/rss/elections': 'Elections',
        'https://news.yahoo.com/rss/politics': 'Politics News',
        'https://news.yahoo.com/rss/business': 'Business',
        'https://news.yahoo.com/rss/entertainment': 'Yahoo Entertainment',
        'https://news.yahoo.com/rss/health': 'Yahoo Health',
        'https://news.yahoo.com/rss/science': 'Science',
        'https://news.yahoo.com/rss/highestrated': 'Most Recommended',
        'https://feeds.fireside.fm/bibleinayear/rss': 'Bible in a Year',
        'https://rss.nytimes.com/services/xml/rss/nyt/Space.xml': 'Space and Beyond',
        'https://rss.nytimes.com/services/xml/rss/nyt/Science.xml': 'NYTimes Science',
        'https://rss.nytimes.com/services/xml/rss/nyt/Climate.xml': 'Climate and Environment',
        'https://rss.nytimes.com/services/xml/rss/nyt/Arts.xml': 'Art',
        'https://rss.nytimes.com/services/xml/rss/nyt/Movies.xml': 'Movies',
        'https://rss.nytimes.com/services/xml/rss/nyt/Music.xml': 'Music',
        'https://rss.nytimes.com/services/xml/rss/nyt/Theater.xml': 'Theater',
        'https://rss.nytimes.com/services/xml/rss/nyt/Television.xml': 'TV',
        'https://rss.nytimes.com/services/xml/rss/nyt/FashionandStyle.xml': 'Style and Fashion',
        'https://rss.nytimes.com/services/xml/rss/nyt/DiningandWine.xml': 'Wine and Dine',
        'https://rss.nytimes.com/services/xml/rss/nyt/Weddings.xml': 'Love and Weddings',
        'https://rss.nytimes.com/services/xml/rss/nyt/Travel.xml': 'Travel and Leisure',
        'https://rss.nytimes.com/services/xml/rss/nyt/Automobiles.xml': 'Cars, cars, cars',
        'https://rss.nytimes.com/services/xml/rss/nyt/MostViewed.xml': 'NY Times MostViewed',
        'https://content.api.nytimes.com/svc/news/v3/all/recent.rss': 'Latest News',
        'https://moxie.foxnews.com/google-publisher/us.xml': 'Foxnews US',
        'https://moxie.foxnews.com/google-publisher/world.xml': 'Foxnews World',
        'https://moxie.foxnews.com/google-publisher/sports.xml': 'Fox Sports',
        'https://moxie.foxnews.com/google-publisher/travel.xml': 'Travels',
        'https://moxie.foxnews.com/google-publisher/tech.xml': 'Fox Tech',
        'https://moxie.foxnews.com/google-publisher/health.xml': 'Health News',
        'https://moxie.foxnews.com/google-publisher/science.xml': 'Fox Science',
        'https://www.latimes.com/local/rss2.0.xml': 'LA Times',
        'https://www.politico.com/rss/politicopicks.xml': 'Politics',
        'https://cdn.feedcontrol.net/8/1114-wioSIX3uu8MEj.xml': 'Headlines',
        'http://www.ynet.co.il/Integration/StoryRss2.xml': 'ynet hebrew',
        custom: 'custom',
        embedded: 'embedded'
    };

    group: FormGroup;
    tableButtons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];

    @ViewChild('dtable') dtable: any;

    @ViewChild(ButtonBarComponent) addRemoveBarComponent: ButtonBarComponent;

    constructor(
        private translocoService: TranslocoService, 
        public override storeSelector: StoreSelectorsService, 
        public override dialog: MatDialog, 
        private toastr: ToastrService,
        private fb: FormBuilder
    ) {
        super(storeSelector, dialog);
        this.tableButtons = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
        ];
        this.tableColumns = [
            {
                inputType: 'edit',
                name: 'title',
                maxStringSize: '20'
            },
            {
                inputType: 'edit',
                name: 'description',
                maxStringSize: '30'
            },
        ];

        this.initRssNames();
    }

    override onInit(): void {
        super.onInit();
        this.group = this.fb.group({
            rssEmbeddedTableControl: []
        });
    }

    override componentInit() {
        super.componentInit();
        const rssValue = this.sceneItem?.Data?.[0]?.Rss?.[0]?.$?.url;
        const rssEmbedded = this.sceneItem?.Data?.[0]?.Rss[0]?.rss?.[0]?.channel?.[0]?.item;
        if (rssEmbedded) {
            this.rssEmbeddedDataSource = rssEmbedded;
            this.setUiConfigValue('url', 'none');
            this.setUiConfigValue('minRefreshTime', '0');
            this.setUiConfigValue('feed', 'embedded');
        } else {
            this.rssEmbeddedDataSource = [];
            const foundRssName = this.rssLinks[rssValue];
            foundRssName === undefined ? this.setUiConfigValue('feed', 'custom') : this.setUiConfigValue('feed', foundRssName);
        }
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.toggleDirection();
        const rssValue = this.sceneItem?.Data?.[0]?.Rss?.[0]?.$?.url;
        const rssEmbedded = this.sceneItem?.Data?.[0]?.Rss[0]?.rss?.[0]?.channel?.[0]?.item;
        if (rssEmbedded) {
            this.rssEmbeddedDataSource = rssEmbedded;
            this.group.get('rssEmbeddedTableControl').setValue(rssEmbedded || []);
        } else {
            this.rssEmbeddedDataSource = [];
            this.group.get('rssEmbeddedTableControl').setValue([]);
            this.setFormValue('url', rssValue);
        }
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "select",
                label: this.translocoService.translate('general.feed', {}, this.translocoService.getActiveLang()),
                name: "feed",
                value: "Tech",
                options: this.rssNames
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.url', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "url",
                storePath: 'Data[0].Rss[0].$.url'
            },
            {
                type: "radiobutton",
                label: this.translocoService.translate('general.direction', {}, this.translocoService.getActiveLang()),
                name: "vertical",
                options: ["horizontal", "vertical"],
                value: "horizon",
                storePath: 'Data[0].Rss[0].$.vertical'
            },
            {
                type: "radiobutton",
                label: this.translocoService.translate('general.textDirection', {}, this.translocoService.getActiveLang()),
                name: "rtl",
                options: ["LTR", "RTL"],
                value: "RTL",
                storePath: 'Data[0].Rss[0].$.rtl'
            },
            {
                type: "input",
                value: '1',
                label: this.translocoService.translate('general.speed', {}, this.translocoService.getActiveLang()),
                min: '1',
                max: '999',
                inputType: "number",
                name: "speed",
                storePath: 'Data[0].Rss[0].$.speed',
                validations: [
                    {
                        name: "required",
                        validator: Validators.required,
                        message: "value required"
                    },
                    {
                        name: "pattern",
                        validator: Validators.pattern("^[0-9]+$"),
                        message: "Accept only numbers"
                    }
                ]
            },
            {
                type: "input",
                value: '30',
                label: this.translocoService.translate('general.requestDataMinutes', {}, this.translocoService.getActiveLang()),
                min: '2',
                max: '1440',
                step: '1',
                inputType: "number",
                name: "minRefreshTime",
                storePath: 'Data[0].Rss[0].$.minRefreshTime',
                validations: [
                    {
                        name: "required",
                        validator: Validators.required,
                        message: "value required"
                    },
                    {
                        name: "pattern",
                        validator: Validators.pattern(/^\d*\.?\d*$/),
                        // validator: Validators.pattern("^[a-zA-Z]+$"),
                        message: "Accept only numbers"
                    }
                ]
            }
        ];
    }

    private initRssNames() {
        Object.keys(this.rssLinks).forEach(field => {
            this.rssNames.push(this.rssLinks[field]);
        });
    }

    override submit(formValues) {
        return super.submit(formValues, (values: Array<ISceneItemNewValues>) => {
            let url = Object.keys(this.rssLinks).find((k) => this.rssLinks[k] === formValues.feed);
            const rssValue = this.sceneItem.Data[0]?.Rss?.[0]?.$?.url;
            const rssEmbedded = this.sceneItem?.Data?.[0]?.Rss?.[0]?.rss?.[0]?.channel?.[0]?.item;

            /** switching Store JSON structure to -> embedded RSS **/
            if (rssValue && url === 'embedded') {
                this.storeSelector.dispatch(actionUpdateSceneItem({
                        sceneId: this.sceneId,
                        sceneItemId: this.sceneItem.$.id,
                        values: [{
                            key: 'rss',
                            value: values,
                            storePath: 'Data[0].Rss[0]',
                            preProcessFunction: (sceneItemNewValues, draft, action, sceneTreeSlice) => {
                                const path = sceneTreeSlice.sceneItem?.Data?.[0]?.Rss?.[0]?.$;
                                delete path['url'];
                                delete path['minRefreshTime'];
                                const entry = {title: [this.defaultValue], description: [this.defaultValue]};
                                const newValue: any = [{channel: [{item: [entry]}]}];
                                const path2 = sceneTreeSlice.sceneItem?.Data?.[0]?.Rss?.[0];
                                path2.rss = newValue;
                                values.splice(values.findIndex((v) => v.key === 'url'), 1);
                                values.splice(values.findIndex((v) => v.key === 'minRefreshTime'), 1);
                            }
                        }]
                    })
                );
                this.storeSelector.dispatch({type: 'BREAK_MERGE'});
            }

            /** switching the Store JSON structure to -> default / non embedded RSS **/
            if (rssEmbedded && url !== 'embedded') {
                this.storeSelector.dispatch(actionUpdateSceneItem({
                        sceneId: this.sceneId,
                        sceneItemId: this.sceneItem.$.id,
                        values: [{
                            key: 'rss',
                            value: values,
                            storePath: 'Data[0].Rss[0]',
                            preProcessFunction: (sceneItemNewValues, draft, action, sceneTreeSlice) => {
                                const path = sceneTreeSlice.sceneItem?.Data?.[0]?.Rss?.[0];
                                delete path['rss'];
                                const path2 = sceneTreeSlice.sceneItem?.Data?.[0]?.Rss?.[0]?.$;
                                path2.url = '';
                                path2.minRefreshTime = '1';
                            }
                        }]
                    })
                );
                this.storeSelector.dispatch({type: 'BREAK_MERGE'});
            }

            switch (url) {
                case 'embedded': {
                    values.splice(values.findIndex((v) => v.key === 'url'), 1);
                    values.splice(values.findIndex((v) => v.key === 'minRefreshTime'), 1);
                    break;
                }

                case 'custom': {
                    url = formValues.url;
                    values[values.findIndex((v) => v.key === 'url')].value = url;
                    break;
                }

                default: {
                    values[values.findIndex((v) => v.key === 'url')].value = url;
                    break;
                }
            }
            return values;
        });
    }

    onEmbeddedAdded() {
        const newValues = _.cloneDeep(this.rssEmbeddedDataSource);
        newValues.push({title: [this.defaultValue], description: [this.defaultValue]});
        const changes = [];
        changes.push({
            key: 'item',
            value: [...newValues],
            storePath: 'Data[0].Rss[0].rss[0].channel[0]'
        });
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: changes
        });
    }

    toggleDirection() {
        const vertical = this.sceneItem?.Data?.[0]?.Rss[0].$.vertical;
        if (vertical) {
            this.showDescriptionFontSelector = vertical === '1';
        }
    }

    onCallBackValue() {
        return (item, direction) => {
            switch (direction) {
                case 'IN': {
                    item.$ = {
                        title: item.title ? item.title[0] : '',
                        description: item.description ? item.description[0] : ''
                    };
                    return item;
                }
                case 'OUT': {
                    item.title = [_.isEmpty(item.$.title.trim()) ? this.defaultValue : item.$.title ];
                    item.description = [_.isEmpty(item.$.description.trim()) ? this.defaultValue : item.$.description ];
                    delete item.$;
                    return item;
                }
            }
        };
    }

    onTableUpdate(e) {
        switch (e.currentAction) {
            case 'added': {
                this.onEmbeddedAdded();
                break;
            }
            case "rename":
            case "drop": {
                this.dispatchSceneItemChanges({
                    sceneId: this.sceneId,
                    sceneItemId: this.sceneItem.$.id,
                    values: [{
                        key: 'item', 
                        value: e.values, 
                        storePath: 'Data[0].Rss[0].rss[0].channel[0]'
                    }]
                });
                break;
            }
            case 'removed': {
                if (!e.selected || !e.selected[0]) {
                    return;
                }

                this.dispatchSceneItemChanges({
                    sceneId: this.sceneId,
                    sceneItemId: this.sceneItem.$.id,
                    values: [{
                        key: 'item', 
                        value: e.values, 
                        storePath: 'Data[0].Rss[0].rss[0].channel[0]'
                    }]
                });
                break;
            }
        }
    }
}

